import { render, staticRenderFns } from "./Addproduct-SK.vue?vue&type=template&id=2cfbe46c&"
import script from "./Addproduct-SK.vue?vue&type=script&lang=js&"
export * from "./Addproduct-SK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports